import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";
import AnimatedSection from "../AnimatedSection";

const Github = () => {
  return (
    <AnimatedSection direction="up" delay={0.2}>
      <Row className="github-calendar-section" style={{ justifyContent: "center", paddingBottom: "10px", margin: "0 auto", maxWidth: "1000px" }}>
        <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
          Days I <strong className="yellow">Code</strong>
        </h1>
        <GitHubCalendar
          username="buntychakraborty"
          blockSize={15}
          blockMargin={5}
          color="#6102ce"
          fontSize={16}
        />
      </Row>
    </AnimatedSection>
  );
}

export default Github;
